import { React, useEffect, useState } from "react";
import GlobalLoadingSpinner from "../../components/GlobalLoadingSpinner";
import { Button, TextField, FormControlLabel, Switch } from "@mui/material";
import ModalPopup from "../../components/ModalPopup";
import MerchantStoreForm from "../../components/Forms/MerchantStoreForm";
// import MerchantStoreForm from "./Forms/MerchantStoreForm";
// import EntityCardDisplay from "../../components/EntityCardDisplay";
import StoreIcon from "@mui/icons-material/Store";
import { api } from "../../utils/api";
import { useBasicSearch } from "../../hooks/useBasicSearch";
import { COLORS } from "../../utils/colors";
import { useNavigate } from "react-router-dom";
import EmptyState from "../EmptyStates/EmptyState";
import NewEntityCardDisplay from "../../components/NewEntityCardDisplay";
import MerchantStoreList from "../../components/MerchantStoreList";
import StoreList from "./StoreList";
import { useAuth0 } from "@auth0/auth0-react";

const MerchantStore = () => {
  const [merchantStoreOption, setMerchantStoreOption] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showMerchantStoreForm, setShowMerchantStoreForm] = useState(false);
  const [includeInactive, setIncludeInactive] = useState(false);
  const { filteredData, search, setSearch } = useBasicSearch(merchantStoreOption);

  const displayData = filteredData;
  const currentUser = JSON.parse(sessionStorage.getItem('currentUser') ?? null)
  const { user } = useAuth0();

  const storesQueryParams = new URLSearchParams();
  if (includeInactive) {
    storesQueryParams.set("includeInactive", "true");
  }
  // Merchant Store admin view must include stores disabled for new signups.
  storesQueryParams.set("includeSignupDisabled", "true");
  const storesQuerySuffix = storesQueryParams.toString()
    ? `?${storesQueryParams.toString()}`
    : "";

  const fetchMerchantStores = async () => {
    try {

      let response;
      switch (sessionStorage.getItem("selectedPortal")) {
        case "Administrator":
          response = await api(`v1/merchantStore/all${storesQuerySuffix}`, "GET");
          break;
        case "Merchant":
          // Use the new endpoint to get all stores across all merchant accounts for this user
          if (user?.email) {
            response = await api(
              `v1/merchant/user-stores/${encodeURIComponent(user.email)}${storesQuerySuffix}`,
              "GET"
            );
          } else if (currentUser?.email) {
            // Fallback to currentUser email if Auth0 user is not available
            response = await api(
              `v1/merchant/user-stores/${encodeURIComponent(currentUser.email)}${storesQuerySuffix}`,
              "GET"
            );
          } else {
            // Fallback to old behavior if email is not available
            response = await api(
              `v1/merchant/${currentUser?.merchantAccount}${storesQuerySuffix}`,
              "GET"
            );
          }
          break;
        default:
          response = null;
          break;
      }

      if (response?.data?.success) {
        // Handle both new endpoint format (merchantStores) and old format (merchant.stores or allMerchantStores)
        let merchantStoreOptions = response.data.data.merchantStores || 
                                   response.data.data.allMerchantStores || 
                                   response.data.data.merchant?.stores || 
                                   [];

        setMerchantStoreOption(merchantStoreOptions);
      }
    } catch (error) {
      console.error("API error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMerchantStores();
  }, [includeInactive, user?.email]);

  const triggerMerchantStoreListUpdate = (merchantStore) => {
    console.log("New/Updated Merchant Store: ", merchantStore);
    setShowMerchantStoreForm(false);
    setLoading(false);
    fetchMerchantStores();
  };
  const navigate = useNavigate();

  const AddNewStore = () => (
    <Button
      sx={{ backgroundColor: COLORS.priorityBlue.hex }}
      variant="contained"
      onClick={() => setShowMerchantStoreForm(true)}
    >
      Add New Merchant Store
    </Button>
  );

  return (
    <div className="page merchantStore w-full flex flex-column items-center p-4">
      <div className="pageTitle flex flex-col w-full text-center lg:flex-row lg:text-left lg:justify-between mb-8">
        <h2>Merchant Store</h2>
        <div className="flex flex-col items-end gap-1">
          <div className="flex flex-wrap items-center gap-4">
            <TextField
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              variant="outlined"
              size="small"
              sx={{ width: "350px" }}
              placeholder="Search for a merchant store"
            />
            <AddNewStore />
          </div>
          <FormControlLabel
            sx={{ marginTop: 2 }}
            control={
              <Switch
                checked={includeInactive}
                onChange={(e) => setIncludeInactive(e.target.checked)}
                color="primary"
              />
            }
            label="Show all stores (including deleted)"
          />
          <ModalPopup
            showModal={showMerchantStoreForm}
            handleShowModal={() => setShowMerchantStoreForm(false)}
            popupTitle="Add New Merchant Store"
            popupContent={
              <MerchantStoreForm
                handleDisplayModal={triggerMerchantStoreListUpdate}
                cancelModal={() => {
                  setShowMerchantStoreForm(false);
                }}
              />
            }
          />
        </div>
      </div>
      <div className="flex w-full justify-center container">
        {loading ? (
          <GlobalLoadingSpinner />
        ) : merchantStoreOption.length === 0 ? (
          <EmptyState type="merchantStore" text="Looks like there are no store yet." action={<AddNewStore />} />
        ) : displayData.length === 0 ? (
          <EmptyState
            type="parnerPricing"
            text={includeInactive ? "No merchant store match your search." : "No active merchant stores."}
          />
        ) : (
          <StoreList data={displayData} />
        )}
      </div>
    </div>
  );
};

export default MerchantStore;
